<template>
    <v-container class="pt-0" fluid>
        <v-card class="px-5 py-3 br-15 w-100" elevation="0">
            <v-row>
                <v-col cols="8">
                    <v-toolbar-title class="page-title">Acordos GC</v-toolbar-title>
                </v-col>
                <v-col cols="2">
                    <v-btn
                        class="new-button w-100"
                        color="primary"
                        @click="$refs.formulario.novo(usuarioTipo)"
                        v-if="['rd'].includes(usuarioTipo)"
                    >
                        <v-icon left>mdi-plus-thick</v-icon> Criar acordo GC
                    </v-btn>
                </v-col>
                <v-col cols="2" v-if="['rd'].includes(usuarioTipo)">
                    <v-menu offset-y>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                color="primary"
                                class="new-button w-100"
                                dark
                                v-bind="attrs"
                                v-on="on"
                            >
                                <v-icon left>mdi-microsoft-excel</v-icon>
                                Exportar
                            </v-btn>
                        </template>
                        <v-list>
                            <v-list-item @click="exportar('acordos')">
                                <v-list-item-title>Acordos</v-list-item-title>
                            </v-list-item>
                            <v-list-item @click="exportar('acordosComProdutos')">
                                <v-list-item-title>Acordos com Produtos</v-list-item-title>
                            </v-list-item>
                            <v-list-item @click="exportar('acordosPorLoja')">
                                <v-list-item-title>Exportação Por Loja</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </v-col>
            </v-row>
            <filtro ref="filtro" @filtrar="filtrar" @limpar="limpar"></filtro>
        </v-card>

        <indicadores
            v-if="usuarioTipo == 'rd'"
            ref="indicadores"
            :indicadores="indicadores"
            :filtro="$refs.filtro"
        ></indicadores>

        <formulario ref="formulario" @filtrar="filtrar"></formulario>

        <v-card elevation="0" class="br-15 pa-5 involucroAcordo">
            <v-data-table
                :headers="headers"
                :items="acordos"
                :server-items-length="totalAcordos"
                item-key="id_acordo_gc"
                fixed-header
                multi-sort
                :items-per-page="5"
                :footer-props="{
                    'items-per-page-options': [5, 10, 50, 100, 500, -1],
                    itemsPerPageText: 'Linhas por páginas',
                    ofText: 'de',
                    pageText: '{0}-{1} de {2}',
                }"
                :options.sync="pagination"
                class="tabela paginacao-esquerda flex-table"
            >
                <template v-slot:[`item.actions`]="{ item }">
                    <v-menu
                        offset-y
                        min-width="180"
                        content-class="acordo-menu"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                dark
                                color="#f2f2f2"
                                v-bind="attrs"
                                v-on="on"
                                small
                                class="px-1"
                                style="min-width: unset"
                            >
                                <v-icon color="#CCC">mdi-menu</v-icon>
                            </v-btn>
                        </template>
                        <v-card>
                            <v-list dense nav>
                                <v-list-item
                                    v-if="
                                        statusAcesso(item.id_status, 'editar') &&
                                        mesVigenteOuMaior(item.mes) &&
                                        usuarioTipo == 'rd'
                                    "
                                    link
                                    @click="$refs.formulario.editar(item)"
                                >
                                    <v-list-item-icon>
                                        <v-icon color="primary">mdi-pencil</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title>Editar Acordo</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item
                                    link
                                    @click="$refs.dialogo.historico(item)"
                                >
                                    <v-list-item-icon>
                                        <v-icon color="primary">mdi-file-document-outline</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title>Histórico</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item
                                    link
                                    @click="$refs.formulario.editar(item, true)"
                                >
                                    <v-list-item-icon>
                                        <v-icon color="primary">mdi-file-document-edit</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title>Exibir Acordo</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item
                                    v-if="item.planograma"
                                    link
                                    @click="$refs.dialogo.planograma(item)"
                                >
                                    <v-list-item-icon>
                                        <v-icon color="primary">mdi-image</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title>Planograma</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item
                                    v-if="
                                        statusAcesso(item.id_status, 'editar') &&
                                        mesVigenteOuMaior(item.mes) &&
                                        usuarioTipo == 'rd'
                                    "
                                    link
                                    @click="$refs.dialogo.planogramaEditar(item)"
                                >
                                    <v-list-item-icon>
                                        <v-icon color="primary">mdi-image-edit</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title>Editar Planograma</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item
                                    v-if="
                                        statusAcesso(item.id_status, 'cancelar') &&
                                        mesVigenteOuMaior(item.mes) &&
                                        usuarioTipo == 'rd'
                                    "
                                    link
                                    @click="$refs.dialogo.cancelar(item)"
                                >
                                    <v-list-item-icon>
                                        <v-icon color="error">mdi-close</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title>Cancelar Acordo</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                        </v-card>
                    </v-menu>
                </template>
            </v-data-table>

            <dialogo
                ref="dialogo"
                @filtrar="filtrar"
            ></dialogo>

            <v-overlay :value="carregando">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>

            <v-snackbar
                v-model="alerta"
                :color="alertaColor"
                :timeout="alertaTimeout"
                top
                style="z-index: 400"
            >
                <v-alert :type="alertaColor">
                    {{ alertaTexto }}
                </v-alert>
                <v-btn dark text class="float-right" @click="alerta = false">
                    Fechar
                </v-btn>
            </v-snackbar>
        </v-card>
    </v-container>
</template>

<script>
import Filtro from "./Filtro.vue";
import Dialogo from "./Dialogo.vue";
import Indicadores from "./Indicadores.vue";
import Formulario from "./formulario/Formulario.vue";

export default {
    components: {
        Filtro,
        Dialogo,
        Indicadores,
        Formulario,
    },
    provide() {
        return {
            listaCampos: this.listaCampos(),
            usuarioTipo: this.usuarioTipo,
        };
    },
    data() {
        return {
            headers: [
                {
                    text: "Menu",
                    value: "actions",
                    sortable: false,
                    align: "center",
                    class: "th-separador",
                },
                {
                    text: "Acordo GC",
                    value: "id_acordo_gc",
                    align: "center",
                    class: "th-separador",
                },
                {
                    text: "Bandeira",
                    value: "bandeira",
                    align: "center",
                    class: "th-separador",
                },
                {
                    text: "Contrato",
                    value: "id_contrato_gc",
                    align: "center",
                    class: "th-separador",
                },
                {
                    text: "Mês",
                    value: "mes_formatado",
                    align: "center",
                    class: "th-separador",
                },
                {
                    text: "Status",
                    value: "status_nome",
                    align: "center",
                    class: "th-separador",
                },
                {
                    text: "Projeto",
                    value: "projeto",
                    align: "center",
                    class: "th-separador",
                },
                {
                    text: "Espaço GC",
                    value: "espaco_nome",
                    align: "center",
                    class: "th-separador",
                },
                {
                    text: "Usuário que Criou",
                    value: "usuario_criacao",
                    sortable: true,
                    align: "center",
                    class: "th-separador",
                },
                {
                    text: "Criado em",
                    value: "data_criacao_formatado",
                    align: "center",
                    class: "th-separador",
                },
            ],
            acordos: [],
            indicadores: {},
            statusIndicadores: [],
            totalAcordos: 0,
            pagination: {},
            carregando: false,
            status: [],
            alerta: false,
            alertaTexto: "",
            alertaColor: "error",
            alertaTimeout: 3000,
        };
    },
    computed: {
        mesAtual() {
            return this.$moment().format("YYYY-MM");
        },
        mesAnterior() {
            return this.$moment().subtract(1, "months").format("YYYY-MM");
        },
        usuarioTipo() {
            const usuario = this.$store.getters.getUsuario;
            if (usuario.id_fornecedor) {
                return "fornecedor";
            }
            return "rd";
        },
    },
    watch: {
        pagination: {
            handler() {
                this.filtrar(false);
            },
            deep: true,
        },
    },
    methods: {
        async filtrar(paginaInicial = true) {
            if (!this.$refs.filtro.validate()) return;

            this.carregando = true;

            var filtro = this.$refs.filtro.filtro;
            var data = {};

            data.mesInicial = filtro.mesInicial || this.$moment().format("YYYY-MM");
            data.mesFinal = filtro.mesFinal || this.$moment().format("YYYY-MM");
            data.cluster_rede = filtro.cluster_rede || [];
            data.id_espaco_gc = filtro.id_espaco_gc || [];
            data.id_categoria = filtro.id_categoria || [];
            data.id_status = filtro.id_status || [];
            data.id_acordo_gc = filtro.id_acordo_gc ? [filtro.id_acordo_gc] : [];
            data.id_contrato_gc = filtro.id_contrato_gc ? [filtro.id_contrato_gc] : [];
            data.statusIndicadores = this.statusIndicadores;

            if (paginaInicial) this.pagination.page = 1;
            data.pagination = this.pagination;

            try {
                var response = await this.$http().post("/acordoGC/lista", {
                    data: data,
                });

                var result = response.data.result || response.data;
                this.acordos = result.lista || [];
                this.totalAcordos = result.total || 0;
                this.indicadores = this.normalizaIndicadores(result.indicadores || {});
            } catch (error) {
                // Mock data para desenvolvimento
                this.acordos = this.gerarMockAcordos();
                this.totalAcordos = this.acordos.length;
                this.indicadores = { 1: 5, 15: 3, 16: 8, 28: 2 };
            }

            this.carregando = false;
        },
        gerarMockAcordos() {
            const projetos = ["Projeto Alpha", "Projeto Beta", "Projeto Gamma", "Projeto Delta"];
            const espacos = ["Gôndola Principal", "Ponta de Gôndola", "Check-out", "Ilha Promocional"];
            const categorias = ["Higiene", "Beleza", "Medicamentos", "Perfumaria"];
            const statusNomes = ["Aguardando Aprovação", "Aguardando Gestão", "Contrato Emitido", "Cancelado"];
            const statusIds = [1, 15, 16, 28];
            const acordos = [];

            for (let i = 0; i < 20; i++) {
                const idx = i % 4;
                acordos.push({
                    id_acordo_gc: 1000 + i,
                    projeto: projetos[idx],
                    espaco_gc: espacos[idx],
                    id_espaco_gc: idx + 1,
                    categoria: categorias[idx],
                    id_categoria: idx + 1,
                    cluster_rede: i % 2 === 0 ? "Cluster" : "Rede",
                    mes: ("0" + ((i % 12) + 1)).slice(-2),
                    ano: "2026",
                    status: statusNomes[idx],
                    id_status: statusIds[idx],
                    produtos: Math.floor(Math.random() * 20) + 1,
                    filiais: Math.floor(Math.random() * 100) + 10,
                    investimento: `R$ ${(Math.random() * 50000).toFixed(2).replace(".", ",")}`,
                    usuario_criacao: "admin",
                    codigo: 100 + idx,
                });
            }
            return acordos;
        },
        statusAcesso(id_status, acesso) {
            if (Array.isArray(this.status)) {
                const status = this.status.find((e) => e.value == id_status);
                if (status) return true;
            }
            return false;
        },
        mesVigenteOuMaior(mes) {
            if (!mes) return false;
            const mesAcordo = this.$moment(mes).format("YYYY-MM");
            return mesAcordo >= this.$moment().format("YYYY-MM");
        },
        normalizaIndicadores(indicadores) {
            var normalizado = {};
            for (var key in indicadores) {
                if (key.startsWith('status_')) {
                    var id = parseInt(key.replace('status_', ''));
                    if (!isNaN(id)) {
                        normalizado[id] = indicadores[key];
                    }
                }
            }
            return normalizado;
        },
        limpar() {
            this.statusIndicadores = [];
            this.filtrar();
        },
        async exportar(tipoExportacao) {
            if (!this.$refs.filtro.validate()) return;

            const urls = {
                acordos: "/acordoGC/exportar",
                acordosComProdutos: "/acordoGC/exportarComProdutos",
                acordosPorLoja: "/acordoGC/exportarPorLoja",
            };

            this.carregando = true;

            var filtro = this.$refs.filtro.filtro;
            var data = {};

            data.mesInicial = filtro.mesInicial;
            data.mesFinal = filtro.mesFinal;
            data.id_espaco_gc = filtro.id_espaco_gc;
            data.id_categoria = filtro.id_categoria;
            data.cluster_rede = filtro.cluster_rede || [];
            data.id_status = filtro.id_status || [];
            data.id_acordo_gc = filtro.id_acordo_gc ? [filtro.id_acordo_gc] : [];
            data.statusIndicadores = this.statusIndicadores;

            try {
                var response = await this.$http().post(urls[tipoExportacao], {
                    data: data,
                });
                window.location = this.$http("baseURL") + response.data.url;
            } catch (error) {
                this.alerta = true;
                this.alertaColor = "error";
                this.alertaTimeout = 3000;
                this.alertaTexto = "Erro ao exportar. Tente novamente.";
            }

            this.carregando = false;
        },
        async listaCampos() {
            try {
                const response = await this.$http().post(
                    "/acordoGC/listaCampos",
                    {}
                );

                const data = response.data;

                this.status = data.status || [];

                return {
                    espacoGC: data.espaco || [],
                    categorias: data.categoria || [],
                    cluster_rede: data.cluster_rede || [],
                    status: data.status || [],
                };
                } catch (error) {
                    console.error("Erro ao carregar campos para filtro:", error);
                }
        },
    },
};
</script>

<style>
</style>
